// import formatDateTranslates from 'helpers/format-date-i18n.json';
import renderStocksTranslates from 'src-sites/bild/section-project/render-stocks-i18n.json';
import reliabilityIndexTranslates from './reliability-index-i18n.json';
import developerTranslates from './developer-i18n.json';
import configLabelsTranslates from './config-labels-i18n';
import linkToPdf from './assets/reliability.pdf';
import linkToPdfUA from './assets/reliability-ua.pdf';

export default function () {
  return {
    // ...formatDateTranslates,
    ...renderStocksTranslates,
    ...reliabilityIndexTranslates,
    ...developerTranslates,
    ...configLabelsTranslates,

    urlToPdf: {
      ru: linkToPdf,
      ua: linkToPdfUA
    },

    year: {
      ru: 'год',
      ua: 'рік'
    },

    // linkToBackText: {
    //   ru: 'К результатам поиска',
    //   ua: 'До результатів пошуку'
    // },

    newBuildingReliabilityIndex: {
      ru: 'Индекс надёжности новостройки',
      ua: 'Індекс надійності новобудови'
    },
    siteDeveloper: {
      ru: 'Сайт застройщика',
      ua: 'Сайт забудовника'
    },
    get: {
      ru: 'Получить ',
      ua: 'Отримати '
    },
    detailedReport: {
      ru: 'детальный отчёт',
      ua: 'детальний звіт'
    },
    actualDetailedReport: {
      ru: 'актуальный детальный отчёт',
      ua: 'актуальний детальний звіт'
    },
    moreAReliabilityIndexAndDetailReport: {
      ru: 'Больше про индекс и отчёт',
      ua: 'Більше про індекс та звіт'
    },
    howWeCalculateScore: {
      ru: 'Как мы считаем оценку?',
      ua: 'Як ми рахуємо оцінку?'
    },
    apartmentsInComplex: {
      ru: 'Квартиры в {{placeholder}}',
      ua: 'Квартири в {{placeholder}}'
    },

    putIntoOperation: {
      ru: 'Сдан в эксплуатацию',
      ua: 'Зданий в експлуатацію'
    },
    linkToExampleTitle: {
      ru: 'Пример отчёта',
      ua: 'Приклад звіту'
    },
    fieldsMailAndPhoneRequired: {
      ru: 'Поля E-Mail и Телефон обязательны',
      ua: 'Поля E-Mail і Телефон обов\'язкові'
    },

    report: {
      ru: 'Отчёт',
      ua: 'Звіт'
    },
    consultation: {
      ru: 'консультация',
      ua: 'консультація'
    },
    withoutActualization: {
      ru: 'без актуализации',
      ua: 'без актуалізації'
    },
    actualizationTxt: {
      ru: 'актуализация',
      ua: 'актуалізація'
    },
    urgent: {
      ru: 'Срочно',
      ua: 'Терміново'
    },
    reportCreated: {
      ru: 'Отчёт создан',
      ua: 'Звіт створено'
    },
    reportUpdated: {
      ru: 'Отчёт актуализирован',
      ua: 'Звіт актуалізовано'
    },
    goPayment: {
      ru: 'Перейти к оплате',
      ua: 'Перейти до сплати'
    },
    detailedReportH2: {
      ru: 'Детальный отчёт',
      ua: 'Детальний звіт'
    },
    name: {
      ru: 'Имя',
      ua: 'Ім\'я'
    },
    orderComment: {
      ru: 'Комментарий к заказу',
      ua: 'Коментар до замовлення'
    },
    isFree: {
      ru: 'Бесплатно',
      ua: 'Безкоштовно'
    },
    reportNA: {
      ru: 'В течение 3х рабочих дней, мы проведём оценку и отправим вам ссылку на отчёт. Спасибо.',
      ua: 'Протягом 3х робочих днів, ми проведемо оцінку і відправимо вам посилання на звіт. Дякуємо.'
    },
    reportNAAndConsult: {
      ru: 'В течение 3х рабочих дней, мы проведём оценку и отправим вам ссылку на отчёт. После производства отчёта, эксперт свяжется с вами по телефону, чтоб разъяснить содержание отчёта и ответить на ваши вопросы. Спасибо.',
      ua: 'Протягом 3х робочих днів, ми проведемо оцінку і відправимо вам посилання на звіт. Після виробництва звіту, експерт зв\'яжеться з вами по телефону, щоб роз\'яснити зміст звіту і відповісти на ваші запитання. Дякуємо.'
    },
    onlyReport: {
      ru: 'Ссылка на детальный отчёт о надёжности ЖК отправлена на указанную вами почту. Спасибо.',
      ua: 'Посилання на детальний звіт про надійність ЖК відправлено на вказану вами пошту. Дякуємо.'
    },
    actualization: {
      ru: 'Ссылка на детальный отчёт о надёжности ЖК отправлена на указанную вами почту. В течение 3х рабочих дней, мы актуализируем данные и отправим вам ссылку на отчёт повторно. Спасибо.',
      ua: 'Посилання на детальний звіт про надійність ЖК відправлено на вказану вами пошту. Протягом 3х робочих днів, ми актуалізуємо дані і відправимо вам посилання на звіт повторно. Дякуємо.'
    },
    actualizationAndConsult: {
      ru: 'Ссылка на детальный отчёт о надёжности ЖК отправлена на указанную вами почту. В течение 3х рабочих дней, мы актуализируем данные и отправим вам ссылку на отчёт повторно. После актуализации отчёта, эксперт свяжется с вами по телефону, чтоб разъяснить содержание отчёта и ответить на ваши вопросы. Спасибо.',
      ua: 'Посилання на детальний звіт про надійність ЖК відправлено на вказану вами пошту. Протягом 3х робочих днів, ми актуалізуємо дані і відправимо вам посилання на звіт повторно. Після актуалізації звіту, експерт зв\'яжеться з вами по телефону, щоб роз\'яснити зміст звіту та відповісти на ваші питання. Дякуємо.'
    },
    actualizationUrgency: {
      ru: 'Ссылка на детальный отчёт о надёжности ЖК отправлена на указанную вами почту. В течение 24х часов, мы актуализируем данные и отправим вам ссылку на отчёт повторно. Спасибо.',
      ua: 'Посилання на детальний звіт про надійність ЖК відправлено на вказану вами пошту. Протягом 24х годин, ми актуалізуємо дані і відправимо вам посилання на звіт повторно. Дякуємо.'
    },
    actualizationAndConsultAndUrgency: {
      ru: 'Ссылка на детальный отчёт о надёжности ЖК отправлена на указанную вами почту. В течение 24х часов, мы актуализируем данные и отправим вам ссылку на отчёт повторно. После производства отчёта, эксперт свяжется с вами по телефону, чтоб разъяснить содержание отчёта и ответить на ваши вопросы. Спасибо.',
      ua: 'Посилання на детальний звіт про надійність ЖК відправлено на вказану вами пошту. Протягом 24х годин, ми актуалізуємо дані і відправимо вам посилання на звіт повторно. Після виробництва звіту, експерт зв\'яжеться з вами по телефону, щоб роз\'яснити зміст звіту і відповісти на ваші запитання. Дякуємо.'
    },
    orderSuccess: {
      ru: 'Оплата успешна',
      ua: 'Платіж зараховано'
    }
  };
}
